/**
 * 사이드바 상태 관리 Store (Zustand)
 * - 사이드바 열림/닫힘 상태를 전역 관리
 */
import { create } from 'zustand';

/**
 * useSidebarStore
 * - isOpen: 사이드바 열림 상태
 * - toggle: 사이드바 토글 함수
 * - open: 사이드바 열기
 * - close: 사이드바 닫기
 */
function createSidebarStore(set) {
  return {
    isOpen: true, // 기본값: 열림
    toggle() {
      set(function (state) {
        return { isOpen: !state.isOpen };
      });
    },
    open() {
      set({ isOpen: true });
    },
    close() {
      set({ isOpen: false });
    },
  };
}

const useSidebarStore = create(createSidebarStore);

export default useSidebarStore;
